// Manifest shopu jipos.sk (S2 #398). Tvar = bs.config.cs.mjs, hodnoty ze sond
// ops/sweeps/2026-09-17-sk-sonda/ a ops/sweeps/2026-09-22-sk-sonda-api/.

export default {
  shop: {
    code: 'sk',
    name: 'Jipos.sk',
    brand: 'Jipos',
    domain: 'jipos.sk',
    origin: 'https://www.jipos.sk',
    language: 'sk',
    country: 'SK',
    // štátne sviatky a dni pracovného pokoja SR (zákon 241/1993 Z. z.): konec lhůty na vrácení
    // na ně připadající se posouvá na pracovní den (§ 122 OZ SR). Den, který přestal být volný,
    // nanejvýš prodlouží zobrazenou lhůtu o den: nikdy ji nezkrátí.
    holidays: ['1-1', '1-6', '5-1', '5-8', '7-5', '8-29', '9-1', '9-15', '11-1', '11-17', '12-24', '12-25', '12-26'],
    currency: 'EUR',
    // Shoptet SK píše „€6,11" (shoptet.config.currencySymbolLeft = '1')
    currencySymbol: '€',
    currencySymbolLeft: true,
    timeZone: 'Europe/Bratislava',
  },

  // testovací instance SK 818282 (od 23. 9., zrcadlo jipos.sk); offline fixtures
  // i fallback buildu jedou na její CDN cestu, stejně jako CZ na 797093
  instances: {
    live: 591524,
    dev: 818282,
    assetsHost: '818282.myshoptet.com',
  },

  // vlastní vyhledávání (#71, S5 #401): tenant `jipos-sk` v search/data/tenants.json
  // (katalog SK, ceny přepočtené z CZK na EUR kurzem shopu, slovenská pipeline);
  // testovací SK 818282 má vlastní index `jipos-sk-dev` (URL karet na 818282),
  // stejně jako CZ dev 797093 → `jipos-dev`
  search: {
    api: 'https://hledani.jipos.cz',
    tenants: {
      591524: 'jipos-sk',
      818282: 'jipos-sk-dev',
    },
    // jediný ceník SK je hlavní `1` (sonda API 22. 9. §5) — VO v indexu není
    priceLists: [1],
  },

  // SK má HMOTNOSTNÍ tarif se stejnou logikou jako CZ (rozhodnutí Tomáše
  // 2026-09-22: co umí CZ, bude i na SK, kde to dává smysl). Pásma 10/20/30 kg,
  // doprava zdarma nad 99 € jen na výdejní místo v prvním pásmu, nad 30 kg jen
  // Fofr. Ceny: první pásmo = dosavadní SK (výdejní místo 5,19 €, adresa 7,59 €),
  // vyšší pásma v poměrech CZ (69/99/149 a 119/139/199 Kč), Fofr dosavadních
  // 29 €, dobírka 1,67 € (`dev/sk/checkout-2.html`).
  //
  // ⚠️ ADMIN SK TOHLE ZATÍM NEUMÍ (sonda API 2026-09-22): plochý ceník,
  // `allowFreeShipping` vypnuté u všech viditelných metod, adresa do 31,5/39,99 kg
  // a Fofr od 40 kg. Ceník SK se přenastaví podle tohoto bloku v S7
  // (`tools/admin/doprava-cenik.mjs --instance=sk`, tarif `hmotnostni-sk`) —
  // do té doby šablona slibuje tarif, který na SK ještě neplatí, proto SK
  // nejde ven dřív než s tarifem.
  shipping: {
    weightBands: [10, 20, 30],
    freeShipMaxKg: 10,
    freeShipFrom: 99,
    bandPrices: [
      { box: 5.19, addr: 7.59 },
      { box: 7.49, addr: 8.99 },
      { box: 10.99, addr: 12.49 },
    ],
    // SK metodu „PPL – Nadrozměrné zásilky" nemá; nad 30 kg veze Fofr
    oversizeBandPrices: [],
    overFromKg: 30,
    overPrice: 29,
    boxLimits: { GLS: 20, PPL: 28 },
    // adresa jede do konce pásem (nad 30 kg Fofr), jako CZ
    addrLimits: {},
    codFee: 1.67,
    // uzávěrka expedice = CZ (tentýž sklad v Bílině, pátek 14:30 od 2026-10-13)
    dispatchCutoff: { 1: 15, 2: 15, 3: 15, 4: 15, 5: 14.5 },
    // sobotní GLS ani nedělní svoz PPL na SK zatím ne — jsou to dohody pro CZ;
    // zapnout až po ověření u dopravců (rozhodnutí Tomáše 2026-09-22)
    fastRules: [],
    // doručení druhý den jako na CZ SK garantovat neumí (zadání Tomáše 2026-09-29):
    // místo jednoho data rozmezí dvou pracovních dní, „30. 9. – 1. 10." Týká se
    // jen běžného termínu; zapne-li se někdy `fastRules`, závozy zůstanou na
    // jednom datu. Věty o „nasledujúci pracovný deň" v locale/sk/shippingPage.js
    // (jízdní řád) a v textu stránky Doprava a platba v adminu se mění s tímhle číslem.
    deliverySpanDays: 1,
    // začátek termínu = 2. pracovní den po odeslání (#572 V1, rozhodnutí 14. 10. 2026):
    // ostrá SK 25. 9.–8. 10. (474 doručených) má přepravu od předání 2 pd u 86,7 %,
    // 1 pd jen u 4,4 %; slib D+2 – D+3 platí u 97,9 % (D+1 – D+2 u 86,5 %).
    deliveryStartDays: 2,
    // prodejna je v Bílině, tedy v ČR; SK osobní odběr nenabízí (sonda 17. 9.)
    pickup: false,
    // akce na dopravu (CZ #322 PPL 19 Kč) — SK žádnou nemá
    promo: [],
  },

  // VO vrstva na SK odpadá: jediný ceník, skupina „Veľkoobchodný odberateľ"
  // bez ceníku (sonda API 22. 9. §5)
  wholesale: {
    pricelists: {},
  },

  // Tatáž firma i tým jako CZ (Jipos e-market s.r.o., Bílina): /kontakty/ SK
  // nese info@jipos.cz a prodejnu v Bílině (fixture dev/sk/contact.html,
  // 2026-09-22); telefon z kontaktu v adminu SK (sonda API 22. 9.). Rozpis hodin
  // = CZ (tatáž prodejna; SK stránka má neděli ještě „Zavřeno", CZ ji od 2. 9.
  // otevřela). Hodnoty potvrdí klient před S4 (otevřená otázka 4 plánu).
  // Hero SK (den D 25. 9., zadání Tomáše): karty CZ bez prodejny (SK stránku
  // prodejny nemá), tatáž média (nahraná na SFTP SK, ověřeno 200). Ceny v EUR
  // ze stránky ostré SK 25. 9., všechny tři produkty skladem > 5 ks (memory
  // hero-produkt-jen-se-zasobou). Sleva = floor, jako Shoptet. SK nemá blog
  // ani prodejnu na webu → články a štítek „O nás" prázdné (blok se nekreslí).
  homepage: {
    heroDefault: 2, // karta, která hraje bez interakce (krovinorez RS7000)
    hero: [
      {
        // Vizuál E kampaně jako CZ (2026-10-07, ops/hero/2026-10-vyprodej/zaznam.md)
        video: 'codex_20261007_vyprodej_e',
        posterSrc: 'codex_20261007_vyprodej_e.png',
        tone: 'brand',
        overlay: 'none',
        ink: false,
        badge: null,
        title: 'ZĽAVOAKCIA práve beží!',
        desc: 'Zľavy až −40 % na náradie aj záhradnú techniku, len do vypredania zásob.',
        price: null,
        priceOld: null,
        note: null,
        cta: 'Zobraziť zľavy',
        ctaTone: 'white',
        page: 'sale',
        href: null,
      },
      {
        video: 'hf_20260921_140151_7c7bd67f-a51a-457c-b42c-23b208bd8e17',
        posterSrc: 'hf_20260921_140026_66aed9c3-2eae-44e8-81df-09045437a91c.png',
        tone: 'light',
        overlay: 'bottom',
        ink: false,
        badge: 'BESTSELLER',
        title: 'Čistič komína SADPAL 1 kg',
        desc: null,
        price: 6.11,
        priceOld: null,
        note: 'pre kotly, pece aj krby',
        cta: 'Kúpiť',
        ctaTone: null,
        page: null,
        href: '/cistic-komina-a-vsetkych-casti-kotlov-sadpal-1kg/',
      },
      {
        video: 'hf_20260712_131252_734e3d77-55fe-401b-b9ec-16bace86000b',
        posterSrc: 'hf_20260712_124215_8f6b905c-b2cb-45d6-bd04-1c70d74b082a.png',
        tone: 'brand',
        overlay: 'bottom',
        ink: false,
        badge: 'AKCIA TÝŽDŇA',
        title: 'Benzínový krovinorez 3,9 kW',
        desc: null,
        price: 69.63,
        priceOld: 106.15,
        note: null,
        cta: 'Kúpiť',
        ctaTone: null,
        page: null,
        href: '/benzinovy-krovinorez-3-91kw-rs7000--vybava-ondragon/',
      },
      {
        video: 'hf_20260712_123317_88fdd4c7-3970-4326-a492-ef7c512d4436',
        posterSrc: 'hf_20260712_123202_1a2dd80b-3935-4f0e-b4c8-10217a2145a8.png',
        tone: 'light',
        overlay: 'none',
        ink: true,
        badge: null,
        title: 'Doprava od €5,19',
        desc: 'Doručujeme PPL a GLS po celom Slovensku, nad €99 na výdajné miesto zadarmo.',
        price: null,
        priceOld: null,
        note: null,
        cta: 'Viac o doprave',
        ctaTone: null,
        page: 'shipping',
        href: null,
      },
    ],
    articles: [],
    aboutBadge: null,
  },

  contact: {
    email: 'info@jipos.cz',
    phone: '+420 605 259 666',
    showPhones: false,
    billingEmail: 'fakturace@jipos.cz',
    openHours: {
      0: { from: 8.5, to: 13 },
      1: { from: 7.5, to: 17 },
      2: { from: 7.5, to: 17 },
      3: { from: 7.5, to: 17 },
      4: { from: 7.5, to: 17 },
      5: { from: 7.5, to: 17 },
      6: { from: 8.5, to: 13 },
    },
    supportHours: {
      1: { from: 8, to: 15 },
      2: { from: 8, to: 15 },
      3: { from: 8, to: 15 },
      4: { from: 8, to: 15 },
      5: { from: 7.5, to: 14.5 },
    },
    // role strojově ze CZ, korektura se slovenskými texty šablony (S3, otázka 2)
    expert: { name: 'Veronika', role: 'Vedúca e-shopu', photo: 'poradce-veronika.jpg' },
    team: [
      { name: 'Veronika', role: 'Vedúca e-shopu', slot: 'teamVeronika', icon: 'user' },
      { name: 'Andrea', role: 'Zástupca konateľa', slot: 'teamAndrea', icon: 'user' },
      { name: 'Nikola', role: 'Vedúca zákazníckej podpory', slot: 'teamSupport', icon: 'headset' },
    ],
  },

  // SK osobní odběr nenabízí (sonda 17. 9.) — údaje jsou sídlo firmy a prodejna,
  // kterou uvádí /kontakty/; nabídku odběru vypíná feature flag v S4.
  store: {
    address: 'Teplická 906, 418 01 Bílina',
    place: 'Bílina, Teplická 906',
    // zápis firmy v Google Maps se jmenuje „Jipos.cz" (týž jako na CZ)
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=Jipos.cz+Teplick%C3%A1+906+B%C3%ADlina',
  },

  // SK nemá Heureku, Zboží ani Retino (sonda 17. 9.).
  // Den D 25. 9. (zadání Tomáše „musí být dnes"): SK vlastní platformu s čísly
  // nemá (nativní hodnotenie-obchodu SK = 2 hodnocení), proto ukazuje hodnocení
  // TÉŽE firmy — Heureka.cz a Google (tatáž prodejna v Bílině) s čísly CZ
  // manifestu (tvar řádku a metrika: komentář `reviews` v bs.config.cs.mjs).
  // Zboží.cz a Firmy.cz jsou české katalogy, na SK nejsou. Tenant `jipos-sk`
  // `reviews_file` nemá (recenze U6), `/reviews/summary` i `/reviews/context`
  // vrací prázdno a platí čísla a citace odtud. Citace jsou doslovné zákaznické
  // (needitují se ani nepřekládají). Odznaky: jen Heureka (Firmy TOP firma je
  // český katalog, Retino SK nemá).
  reviews: {
    // pokladna SK dál ukazuje cenu dopravy: hodnocení Heureka.cz tam nepatří
    checkoutTile: false,
    customers: 30000,
    // sekce „Ako recenzie overujeme" na stránce hodnocení: SK recenze z webu na
    // detailu zatím neukazuje (recenze U6), sekci ani odkazy na ni nemá
    verifyAnchor: null,
    platforms: [
      { key: 'heureka', logo: 'heureka', name: 'Heureka', metric: 'pct', value: 96, count: 6930, href: 'https://obchody.heureka.cz/jipos-cz/recenze/', pool: null, own: false },
      { key: 'google', logo: 'google', name: 'Google', metric: 'stars', value: 4.7, count: 2946, href: 'https://www.google.com/maps/search/?api=1&query=Jipos.cz+Teplick%C3%A1+906+B%C3%ADlina', pool: null, own: false },
    ],
    quotes: [
      { rating: 5, date: '2026-05-30', source: 'heureka', text: 'Rychlost vyřízení objednávky. V sobotu objednáno a následující pondělí dodáno.' },
      { rating: 5, date: '2026-05-30', source: 'heureka', text: 'Úžasná paní pokladní...odpověděla perfektně na všechny otázky ... poradila i s opravou...' },
      { rating: 5, date: '2026-05-26', source: 'heureka', text: 'Jeden den jsem objednala druhý den jsem zboží měla.Neporušené.' },
    ],
    badges: [
      {
        key: 'heureka',
        src: 'https://im9.cz/cb/12452-12.png',
        href: 'https://obchody.heureka.cz/jipos-cz/recenze/',
        alt: 'Heureka.cz – overené hodnotenie obchodu Jipos',
        w: 130,
        h: 160,
      },
    ],
  },

  // značky mají na SK tytéž slugy pod /znacka/ (fixture dev/sk/brand.html);
  // pás `store` žije na stránce prodejny, kterou SK zatím nemá
  brands: {
    // „Jipos Tools" má na SK slug jipos-7; /znacka/jipos/ je na SK jiná,
    // prázdná značka „JIPOS" (den D 25. 9., filtr výpisu manufacturerId jipos-7)
    own: 'jipos-7',
    footer: [
      { label: 'BULLTECH', slug: 'bulltech' },
      { label: 'ONDRAGON', slug: 'ondragon' },
      { label: 'POWERMAT', slug: 'powermat' },
      { label: 'GEKO', slug: 'geko' },
      { label: 'JIPOS', slug: 'jipos-7' },
    ],
    store: [],
  },

  // SK vlastní profil nemá ověřený — záloha vede na týž profil jako CZ
  // (nativní widget SK, pokud ho shop nese, má přednost)
  instagram: 'https://www.instagram.com/jiposcz/',

  // seznam Ecomailu pro SK zatím nikdo neurčil (otázka 4 plánu) → nativní
  // formulář Shoptetu, jak ho SK má dnes
  newsletter: {
    ecomailAction: null,
    ecomailAccount: null,
    popupWidgetId: null,
  },

  // GTM SK (záloha HTML kódů SK docs/admin-zaloha/html-kody-sk-pred-zasahem.md),
  // GA4 = config nativního gtag SK (fixture dev/sk/home.html); Clarity SK
  // yosqvppry1 od 27. 9. (zadání Tomáše), Smartsupp SK nemá (sonda 17. 9.)
  tracking: {
    gtmId: 'GTM-MG4ML5VS',
    gtmOrigin: 'https://nxa.jipos.sk',
    ga4: 'G-Z2KTG2D0G8',
    clarity: 'yosqvppry1',
    smartsupp: false,
  },

  // SK chat nemá a nedostane (přechod na SupportBox je jen jipos.cz, handover 2026-09-28)
  chat: {
    supportBoxId: null,
    supportBoxSecret: null,
  },

  promo: {
    saleCount: null,
  },

  // Kampaně (plán kampaní 2026-10-06, popis polí v bs.config.cs.mjs). SK nemá
  // výprodej skladu (`pages.clearance` null, příznak custom1 na SK chybí), takže
  // deštník jede nad /zlavoakcia/ bez čísla slevy a bez dlaždice výprodeje.
  // `claimPct` zůstává null, dokud se neověří, že výprodejové ceny na SK dorazily.
  campaigns: [
    {
      id: 'octSale',
      feature: 'campaignOctSale',
      from: '2026-10-06T00:00',
      until: '2026-10-31T23:59:59',
      tone: 'sale',
      page: 'sale',
      claimPct: null,
      tile: null,
      // vizuál E jako CZ (karta akční nabídky v mřížce, SK výprodej skladu nemá)
      photo: {
        desktop: 'codex_20261007_vyprodej_e-promo-desktop.jpg',
        mobile: 'codex_20261007_vyprodej_e-promo-mobile.jpg',
      },
      hero: {
        video: 'codex_20261007_vyprodej_e',
        badge: null,
        title: 'Októbrový výpredaj',
        desc: 'Zľavnené náradie a záhradná technika na jednom mieste.',
        cta: 'Zobraziť výpredaj',
      },
      media: null,
      xmas: null,
    },
    {
      // Black Friday jako CZ (popis polí v bs.config.cs.mjs), bez čísla slevy
      // a bez dlaždice výprodeje skladu
      id: 'blackFriday',
      feature: 'campaignBlackFriday',
      from: '2026-11-01T00:00',
      until: '2026-11-30T23:59:59',
      tone: 'ink',
      page: 'sale',
      claimPct: null,
      tile: null,
      photo: {
        desktop: 'codex_20261019_bf-promo-desktop.jpg',
        mobile: 'codex_20261019_bf-promo-mobile.jpg',
      },
      hero: {
        video: 'codex_20261007_vyprodej_e',
        badge: null,
        title: 'Black Friday',
        desc: 'Zľavnené náradie a záhradná technika na jednom mieste.',
        cta: 'Zobraziť Black Friday',
      },
      media: {
        video: 'codex_20261019_bf',
        posterSrc: 'codex_20261019_bf.png',
        bento: 'codex_20261019_bf-bento.webp',
        bentoMobile: 'codex_20261019_bf-bento-m.webp',
        mega: 'codex_20261019_bf-promo-desktop.jpg',
      },
      xmas: null,
    },
  ],

  sisterShop: {
    code: 'cs',
    label: 'Český e-shop jipos.cz',
  },

  // Kořeny menu SK (fixture dev/sk/home.html, `ul.menu-level-1`, 2026-09-22) —
  // 1:1 obdoba CZ, jen slovenské slugy; SK navíc má kořen /nove-polozky/
  // (bez ikony = fallback).
  catalog: {
    // Rezerva v pracovních dnech mezi předpokládaným příjmem na sklad (export
    // objednávek u dodavatelů, `/specs` → `restock.expected_at`) a datem, které
    // zákazník vidí „Naskladnění očekáváme do …" (restockDate.js). Sklad je
    // společný pro CZ i SK, pracovní dny = svátky ČR (dispatchEta.js).
    restockBufferDays: 2,
    // SK výprodej skladu nemá (příznak custom1 na ostré SK chybí, /vypredaj/ 404)
    clearanceFlag: null,
    roots: {
      garden: '/zahrada/',
      build: '/stavba--dom/',
      workshop: '/dielna/',
      home: '/domacnost/',
      kids: '/vybavenie-a-hracky-pre-deti/',
      car: '/prislusenstvo-pre-automobily/',
      xmas: '/vianoce/',
      ppe: '/ochranne-pracovne-pomocky/',
      solar: '/fotovoltaika/',
    },
  },

  // Slugy ověřené HTTP kódem a sitemapou (sonda 17. 9. §systémové slugy, info
  // stránky SK; tools/fixtures/capture.mjs PAGES_SK; akce = kategorie
  // /zlavoakcia/ z menu SK). null = SK stránku nemá (blog, prodejna, B2B,
  // stav objednávky, výprodej) nebo slug není ověřený (doručovací údaje
  // klientské sekce — bez testovacího zákazníka SK, S4/S6).
  pages: {
    cart: '/kosik/',
    checkout: '/objednavka/',
    // děkovací stránka (body `in-dakujeme`), ověřeno objednávkou 2260900001 na 818282 (2026-09-23)
    checkoutDone: '/objednavka/dakujeme/',
    search: '/vyhladavanie/',
    login: '/login/',
    register: '/registracia/',
    account: '/klient/',
    forgotPassword: '/klient/zabudnute-heslo/',
    accountOrders: '/klient/objednavky/',
    accountSettings: '/klient/nastavenie/',
    accountShipping: null,
    accountDiscounts: '/klient/klient-zlavy/',
    accountDocs: '/klient/klient-doklady/',
    // zbytek sidebaru klientské sekce SK neověřený (bez testovacího zákazníka);
    // odkazy nativního sidebaru pak dostanou obecnou ikonu (NAV_FALLBACK)
    accountProforma: null,
    accountCredit: null,
    accountDeliveryNotes: null,
    accountPayments: null,
    accountReviews: null,
    accountThreads: null,
    brands: '/znacka/',
    blog: null,
    sale: '/zlavoakcia/',
    clearance: null,
    contact: '/kontakty/',
    shipping: '/doprava-a-platba/',
    store: null,
    b2b: null,
    service: '/servis-naradia/',
    ratings: '/hodnotenie-obchodu/',
    claim: '/reklamacny-formular/',
    claimsPolicy: '/reklamacny-poriadok/',
    withdrawal: '/odstupenie-v-lehote-14-dni/',
    // vlastní stránka (#461, ops/changesets/2026-10-07-stav-objednavky-sk)
    orderStatus: '/stav-objednavky/',
    // Časté otázky SK (den D 25. 9., ops/changesets/2026-09-25-faq-sk)
    faq: '/caste-otazky/',
    terms: '/obchodne-podmienky/',
    privacy: '/podmienky-ochrany-osobnych-udajov/',
    shippingOptions: ':moznosti-dorucenia/',
  },
};
